'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const Link = renderWithRef('Link', null, (o, s)=>{
    useDeprecatedProps('Link', o, [
        {
            propName: 'withIconSeparated',
            instructions: 'This prop behaves the same as `withIcon`, use `withIcon` instead.'
        }
    ]);
    let { children: p, skin: a = 'standard', width: l = 'standard', withIcon: d = false, withIconSeparated: f = false, covering: u = false, to: b } = o, w = _object_without_properties(o, [
        "children",
        "skin",
        "width",
        "withIcon",
        "withIconSeparated",
        "covering",
        "to"
    ]), { globalLinkComponent: _ } = useSwanContext(), j = _object_spread_props(_object_spread({}, w), {
        to: b
    });
    _ && (j = _object_spread_props(_object_spread({}, j), {
        as: o.as || o.component || _
    })), o.href || o.as || o.component || o.render || (j = _object_spread({
        href: o.to || void 0
    }, j));
    let y = new Set([
        'swan-link'
    ]);
    return 'standard' !== a && y.add(`swan-link-skin-${a}`), 'full-width' === l && y.add("swan-link-full-width"), (d || f) && y.add('swan-link-with-icon'), f && y.add('swan-link-with-icon-separated'), u && y.add('swan-link-covering'), jsxs(RenderComp, {
        root: "a",
        forwardedRef: s,
        classNames: y,
        props: j,
        children: [
            'cta-left' === a && jsx(Icon, {
                iconType: "arrowLeft"
            }),
            p,
            'cta' === a && jsx(Icon, {
                iconType: "arrowRight"
            })
        ]
    });
});

export { Link };
